const validatePasswordFormat = (password) => {
  const hasOneNumber = /[0-9]/;
  const hasOneLetter = /[a-z]/i;
  return password.length > 7 && hasOneNumber.test(password) && hasOneLetter.test(password);
};

export default validatePasswordFormat;
